export const cardFooter = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}